import React from "react"

import FestExpertArtistInfoContainer from "../../container/CRM/FestExpertCRM/ArtistInfo.container"
import EvaluationFormContainer from "../../container/CRM/FestExpertCRM/EvaluationForm.container"
import HeaderComponent from "../../components/common/Header/Header.component"

import "./style.scss"

const block = "fest-expert-evaluation-page"

const FestExpertEvaluationPage = (): JSX.Element => (
  <div className={block}>
    <HeaderComponent />
    <FestExpertArtistInfoContainer />

    <div className={`${block}__separator`} />

    <div className={`${block}__evaluation-form`}>
      <div className="content-container">
        <EvaluationFormContainer />
      </div>
    </div>
  </div>
)

export default FestExpertEvaluationPage
